(() => {
  if (window.WAAnniversary) { window.WAAnniversary.initAll(); return; }
  const preview = new URLSearchParams(location.search).get('preview_fuenf') === '1';
  const cleanups = new WeakMap();
const EU = new Set('AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE'.split(' '));
const COUNTRIES = new Set('AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW'.split(' '));
function route(country, preferredLanguage) {
  const code = typeof country === 'string' ? country.trim().toUpperCase() : '';
  if (!COUNTRIES.has(code)) return null;
  const language = ['de', 'en'].includes(preferredLanguage) ? preferredLanguage : (['DE', 'AT', 'CH'].includes(code) ? 'de' : 'en');
  const eu = EU.has(code);
  return {country:code, language, optin:eu?'DOI':'SOI', list:eu?'RyM9vn':'RVzavq', form:eu?(language==='de'?'RdjQFs':'Si7rdU'):(language==='de'?'Ubaz5M':'RAt8fT')};
}


  function initSignup(hero) {
    const controls = hero.querySelector('[data-wa-signup-routing]');
    const host = hero.querySelector('[data-wa-form]');
    if (!controls || !host) return () => {};
    const copy = controls.dataset;
    const locale = copy.waLocale === 'en' ? 'en' : 'de';
    const status=document.createElement('p'); status.className='wa-routing-help'; status.setAttribute('role','status');
    controls.replaceChildren(status);
    const shopChoice = () => {
      const country = window._transtore?.countryCurrent?.code || window.Shopify?.country || copy.waCountry;
      const language = window._transtore?.languageCurrent?.locale || window.Shopify?.locale || copy.waLocale;
      const preferred = String(language || locale).toLowerCase().split('-')[0] === 'de' ? 'de' : 'en';
      // Unknown market: show the matching EU form immediately, never assume single opt-in.
      return route(country, preferred) || route('DE', preferred);
    };
    const fallback = hero.querySelector('[data-wa-fallback]');
    const fallbackLink = fallback?.querySelector('a');
    let activeForm=''; let timer; let loadingExpired=false;
    const isReady=()=>!!host.querySelector('[data-wa-embed]:not([hidden]) input[type="email"], [data-wa-embed]:not([hidden]) .klaviyo-form-richtext');
    const syncFallback=()=>{
      const ready=isReady();
      if(fallback) fallback.hidden=ready;
      if(ready){status.textContent='';clearTimeout(timer);}
      else if(loadingExpired) status.textContent='';
    };
    const observer=new MutationObserver(syncFallback);
    observer.observe(host,{childList:true,subtree:true});
    const update=() => {
      const choice=shopChoice();
      hero.dataset.waSignupLanguage=choice.language;
      host.querySelectorAll('[data-wa-embed]').forEach(el => el.hidden = el.dataset.waEmbed !== choice.form);
      if(fallbackLink){
        fallbackLink.href='https://manage.kmail-lists.com/subscriptions/subscribe?a=SWTfkG&g='+choice.list;
        fallbackLink.textContent=choice.language==='de'?'Anmeldung öffnen':'Open signup';
      }
      if(activeForm===choice.form){syncFallback();return;}
      activeForm=choice.form;loadingExpired=false;
      status.textContent=copy.waFormLoading;
      syncFallback();
      clearTimeout(timer);timer=setTimeout(()=>{loadingExpired=true;syncFallback();},15000);
    };
    update();
    // Transtore initializes asynchronously. Its applied market remains the source of truth.
    const contextTimer=setInterval(update,500);
    const localeObserver=new MutationObserver(update);
    localeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['lang']});
    window.addEventListener('pageshow',update);
    return () => {clearInterval(contextTimer);clearTimeout(timer);observer.disconnect();localeObserver.disconnect();window.removeEventListener('pageshow',update);};
  }

  function init(root) {
    if (cleanups.has(root)) return;
    const wrapper = root.closest('.shopify-section') || root;
    const editor = root.dataset.waEditor === 'true';
    const visible = preview || editor || root.dataset.waPublic === 'true';
    wrapper.hidden = !visible;
    if (!visible) return;
    const template = root.querySelector('template[data-wa-anniversary-template]');
    if (template) template.replaceWith(template.content.cloneNode(true));
    const hero = root.querySelector('.wa-five-v4');
    if (!hero) return;
    const cleanupSignup = initSignup(hero);
    // The anniversary replaces the existing homepage hero while visible.
    const previousHero = document.querySelector('[id$="__f_hero_premium_R4Mnpr"]');
    const previousDisplay = previousHero?.style.getPropertyValue('display') || '';
    const previousPriority = previousHero?.style.getPropertyPriority('display') || '';
    previousHero?.style.setProperty('display', 'none', 'important');
    const buttonLabel = hero.dataset.waButton;
    const updateButton = () => {
      if (!buttonLabel) return;
      hero.querySelectorAll('.wa-five-form button').forEach(button => {
        const formId = button.closest('[data-wa-embed]')?.dataset.waEmbed;
        const formLanguage = formId ? (['Si7rdU', 'RAt8fT'].includes(formId) ? 'en' : 'de') : null;
        const shopLanguage = document.documentElement.lang.startsWith('en') ? 'en' : 'de';
        const label = !formLanguage || formLanguage === shopLanguage ? buttonLabel : (formLanguage === 'en' ? 'Get two days of early access' : 'Zwei Tage Vorab-Zugang sichern');
        const current = button.textContent.trim();
        if (current === 'Vorab-Zugang sichern' || current === 'Get early access') {
          const walker = document.createTreeWalker(button, 4);
          let node;
          while ((node = walker.nextNode())) {
            if (node.textContent.trim() === current) node.textContent = label;
          }
        }
      });
    };
    const observer = buttonLabel ? new MutationObserver(updateButton) : null;
    observer?.observe(hero, { childList: true, subtree: true, characterData: true });
    updateButton();
    const target = Number(hero.dataset.waTarget);
    let epoch = Number(root.dataset.waEpoch);
    let anchor = performance.now();
    let after = null;
    // Preview-only phase switch allows review without changing the real countdown.
    const forceAfter = preview && new URLSearchParams(location.search).get('preview_fuenf_phase') === 'collection';
    const tick = () => {
      const remaining = Math.max(0, Math.ceil(target - epoch - (performance.now() - anchor) / 1000));
      const isAfter = forceAfter || remaining === 0;
      if (after !== isAfter) {
        after = isAfter;
        hero.querySelectorAll('[data-wa-before]').forEach(el => el.hidden = isAfter);
        hero.querySelectorAll('[data-wa-after]').forEach(el => el.hidden = !isAfter);
      }
      const parts = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
      hero.querySelectorAll('[data-wa-number]').forEach((el, i) => el.textContent = String(parts[i]).padStart(2, '0'));
    };
    const sync = async () => {
      try {
        const url = new URL(location.pathname, location.origin);
        url.searchParams.set('wa_clock', String(Math.floor(performance.now())));
        const response = await fetch(url, { method: 'HEAD', cache: 'no-store', credentials: 'same-origin' });
        const serverEpoch = Date.parse(response.headers.get('date')) / 1000;
        if (root.isConnected && Number.isFinite(serverEpoch)) { epoch = serverEpoch; anchor = performance.now(); tick(); }
      } catch (_) { /* Liquid's UTC epoch remains the fallback. */ }
    };
    tick();
    const timer = setInterval(() => { if (!root.isConnected) cleanup(); else tick(); }, 1000);
    const visibility = () => { if (!document.hidden) sync(); };
    const cleanup = () => { cleanupSignup(); if (previousHero) { if (previousDisplay) previousHero.style.setProperty('display', previousDisplay, previousPriority); else previousHero.style.removeProperty('display'); } observer?.disconnect(); clearInterval(timer); document.removeEventListener('visibilitychange', visibility); cleanups.delete(root); };
    cleanups.set(root, cleanup);
    document.addEventListener('visibilitychange', visibility);
    sync();
  }
  const initAll = () => document.querySelectorAll('[data-wa-anniversary-root]').forEach(init);
  window.WAAnniversary = { initAll };
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-wa-anniversary-root]').forEach(root => cleanups.get(root)?.()));
  initAll();
})();
